import React from 'react';
import styled from 'styled-components';

const RequirementExceptionPopupRight = styled.div`
  background-color: ${(props) => props.theme.colors.defaultContentBackground};
  border: 1px solid ${(props) => props.theme.colors.defaultContentBorder};
  box-shadow: 0 1px 1px 1px ${(props) => props.theme.colors.shadow};
  max-width: 300px;
  min-width: 80px;
  padding: ${(props) => props.theme.spacing.spacing4};
  position: absolute;
  text-align: left;
  width: 300px;
  z-index: 10;
  * {
    white-space: pre-wrap;
  }
`;

const RequirementExceptionPopupLeft = styled(RequirementExceptionPopupRight)`
  top: 0;
  right: 100%;
  left: auto;
  margin-right: ${(props) => props.theme.spacing.spacing4};
`;

export enum RequirementExceptionPopupPosition {
  left = 'popup--left',
  right = 'popup--right',
}

export interface IRequirementExceptionPopup {
  className?: string;
  style?: React.CSSProperties;
  position?: RequirementExceptionPopupPosition;
  children: React.ReactNode;
}

export const RequirementExceptionPopup: React.FC<IRequirementExceptionPopup> = ({
  className,
  position,
  style,
  children,
}) => {
  return position === RequirementExceptionPopupPosition.right ? (
    <RequirementExceptionPopupRight className={className} style={style}>
      {children}
    </RequirementExceptionPopupRight>
  ) : (
    <RequirementExceptionPopupLeft className={className} style={style}>
      {children}
    </RequirementExceptionPopupLeft>
  );
};
